"use strict";
/**
 * QVET Purchase Orders (Pedidos) Contracts
 * Report ID: 1100
 */
Object.defineProperty(exports, "__esModule", { value: true });
